export default "__VITE_ASSET__CxaWh9sX__"